import { useMemo } from "react";
import { AdHocRenderer } from "@meiden-connect/ui";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { AuthShell } from "./auth/auth-shell";
import { Router } from "./router";
import { RootErrorBoundary } from "./root-error-boundary";
import { ConnectFeedbackWindow } from "./features/connect-feedback-window/connect-feedback-window";

// 最上位コンポーネント。
// - エラー境界
// - TanStack Query Provider
// - MEIDEN CONNECT 認証 Shell（mock / required を切替）
// - 簡易ルータ（/ と /c/:canvasId）
// - Connect Feedback ミニウィンドウ（条件を満たさなければ何も描画しない）
export function App(): JSX.Element {
  const queryClient = useMemo(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            staleTime: 30_000,
            retry: 1,
            refetchOnWindowFocus: false,
          },
        },
      }),
    []
  );

  return (
    <RootErrorBoundary>
      <AdHocRenderer>
        <QueryClientProvider client={queryClient}>
          <AuthShell>
            <Router />
            <ConnectFeedbackWindow />
          </AuthShell>
        </QueryClientProvider>
      </AdHocRenderer>
    </RootErrorBoundary>
  );
}
